import cn from "classnames"
import React from "react"

interface LoadingSpinnerProps {
  className?: string
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ className }) => (
  <div className="flex w-8 items-center justify-center">
    <div className="absolute z-10 h-[26px] w-[26px] rounded-full bg-white-5" />
    <div className={cn("loading-animation absolute h-8 w-8 animate-spin-slow rounded-full bg-spinner", className)} />
  </div>
)

export default LoadingSpinner
